module.exports = __webpack_public_path__ + "media/auto_history/kupno-blue-d8b60c92.svg";